import { render, staticRenderFns } from "./DeletedPrice.vue?vue&type=template&id=8dc832fe&scoped=true&"
import script from "./DeletedPrice.vue?vue&type=script&lang=js&"
export * from "./DeletedPrice.vue?vue&type=script&lang=js&"
import style0 from "./DeletedPrice.vue?vue&type=style&index=0&id=8dc832fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc832fe",
  null
  
)

export default component.exports